import React from "react"

import { StyledCenterContainer } from "./styled"

const CenterContainer = (props) => <StyledCenterContainer {...props} />

export default CenterContainer
